import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { setCredentials } from '../../features/auth/authSlice'
import { Mutex } from 'async-mutex';
const mutex = new Mutex();

const baseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_BASE_URL,
  credentials: 'include',
  prepareHeaders: (headers, { getState }) => {
      const token = getState().auth.token
      if (token) {
        headers.set("authorization", `Bearer ${token}`)
      }
      return headers
  },
  tagTypes: ['Inscription', 'User', 'Group'],
})


const baseQueryWithReauth = async (args, api, extra) => {
  await mutex.waitForUnlock();
  let result = await baseQuery(args, api, extra);

  if (result?.error && [401, 403].includes(result.error.status)) {
    if (!mutex.isLocked()) {
      const release = await mutex.acquire();
      try {
        const refreshResult = await baseQuery('/refresh', api, extra);
        if (refreshResult?.data) {
          api.dispatch(setCredentials({ ...refreshResult.data }));
          result = await baseQuery(args, api, extra);
        } else {
          return refreshResult;
        }
      } finally { release(); }
    } else {
      await mutex.waitForUnlock();
      result = await baseQuery(args, api, extra);
    }
  }
  return result;
};


export const apiSlice = createApi({
  baseQuery: baseQueryWithReauth,
  tagTypes: ['Inscription', 'User', 'Group'],
  endpoints: (builder) => ({})
})